import React from 'react'
import { Link } from 'react-router-dom'

export function DefaultEmptyList() {
    return (
        <div className="flex-1 flex flex-col items-center justify-center w-full">
            <img src={require('../../../assets/bell_icon.svg')} className="h-[108px]" />
            <span className="text-lg text-dark-color-1 mt-4">แจ้งเตือนตามความต้องการของคุณ</span>
            <Link to="/optimus/edit-reminder" className="w-full">
                <button className="bg-primary-blue text-white p-3 rounded-xl mb-2 active:bg-bright-light-blue mt-6 w-full">
                    ตั้งการแจ้งเตือนจ่าย
                </button>
            </Link>
        </div>
    )
}
